export default function debounce(fn, delay) {
  let timeout = null;

  function debounced(...args) {
    const wait = typeof delay === 'function' ? delay(...args) : delay;

    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }

  debounced.cancel = () => clearTimeout(timeout);

  return debounced;
}
